import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addPatientInsurancePolicy = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Patient Insurance Policy',
    // '/api/method/technoerp.services.create_patient_insurance_policy',
    body
  );
  return data;
});
export const updatePatientInsurancePolicy = catchAsync(async ({ body, id }) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Patient Insurance Policy/${id}`,
    // '/api/method/technoerp.services.create_patient_insurance_policy',
    body
  );
  return data;
});
export const updatePatient = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/method/technoerp.services.update_patient',
    body
  );
  return data;
});
export const deletePatientinsurancePolicy = catchAsync(async (record) => {
  const { data } = await axiosInstance.post(
    // `/api/method/technoerp.services.delete_record?record=${record}&document=Patient Insurance Policy`
    `/api/method/technoerp.services.delete_record?record=${record}&document=Insurance Payor Contract`
  );
  return data;
});
export const cancelPatientinsurancePolicy = catchAsync(async (record) => {
  const { data } = await axiosInstance.post(
    `/api/method/technoerp.services.cancel_record?record=${record}&document=Patient Insurance Policy`
  );
  return data;
});

export const getPatientInsurancePolicies = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    // '/api/method/technoerp.services.get_patient_insurance_policies'
    '/api/resource/Patient Insurance Policy?fields=["name","patient_name","insurance_payor","policy_expiry_date","policy_number","insurance_plan","docstatus","gender","patient"]'
  );
  return data;
});

export const getValidPatientInsurancePolicies = catchAsync(
  async (patientNumber) => {
    const { data } = await axiosInstance.get(
      // '/api/method/technoerp.services.get_patient_insurance_policies'
      `/api/method/technoerp.services.get_insurance_policy?patient=${patientNumber}`
    );
    return data;
  }
);
export const getPatientInsurancePoliciesById = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Patient Insurance Policy/${id}`
  );
  return data;
});
export const getInsurancePayors = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_insurance_payors'
  );
  return data;
});
export const getEligibilityPlans = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_eligibility_plans'
  );
  return data;
});

export const getPayorContracts = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Insurance Payor Contract?fields=["insurance_payor","start_date","end_date","is_active","posting_date","default_price_list","name","docstatus"]'
    // '/api/method/technoerp.services.get_insurance_payor_contracts'
  );
  return data;
});
export const getPayorContractsById = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Insurance Payor Contract/${id}`
  );
  return data;
});
export const getPriceListAndRate = catchAsync(async (body) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_price_list_and_rate?insurance_policy=${body?.insurance_policy}&item_code=${body?.item_code}`
  );
  return data;
});
export const deletePayorContract = catchAsync(async (record) => {
  const { data } = await axiosInstance.post(
    // `/api/resource/Insurance Payor Contract/${record}`
    `/api/method/technoerp.services.delete_record?record=${record}&document=Insurance Payor Contract`
  );
  return data;
});
export const cancelPayorContract = catchAsync(async (record) => {
  const { data } = await axiosInstance.post(
    // `/api/resource/Insurance Payor Contract/${record}`
    `/api/method/technoerp.services.cancel_record?record=${record}&document=Insurance Payor Contract`
  );
  return data;
});

export const addPayorContract = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/method/technoerp.services.create_insurance_payor_contract',
    // '/api/method/technoerp.services.create_insurance_payor_contract',
    body
  );
  return data;
});
export const updatePayorContract = catchAsync(async ({ body, id }) => {
  const { data } = await axiosInstance.put(
    `/api/method/technoerp.services.create_insurance_payor_contract/${id}`,
    body
  );
  return data;
});
